import { DomainStatusDTO } from '../../../api/downtime';

export type Status = {
  name: string;
  status: 'unstable' | 'down';
  isEssential: boolean;
  title: string;
  message: string;
};

export const getPrioritizedStatus = (
  statuses: Status[]
): Status | undefined => {
  return [...statuses]
    .sort(s1 => (s1.status === 'down' ? -1 : 1))
    .sort(s1 => (s1.isEssential ? -1 : 1))[0];
};

export const processStatuses = (
  { services }: DomainStatusDTO,
  essentialServices: string[]
): Status[] => {
  return services
    .filter(s => s.isDown || s.isUnstable)
    .map(service => {
      const { name, isDown, isUnstableTitle, isUnstableMessage } = service;

      const isEssential = essentialServices.some(
        essentialService =>
          service.name.toLowerCase() === essentialService.toLowerCase()
      );

      if (isDown) {
        const { isDownTitle, isDownMessage } = service;

        return {
          name,
          status: 'down',
          isEssential,
          title: isDownTitle,
          message: isDownMessage
        };
      }

      return {
        name,
        status: 'unstable',
        isEssential,
        title: isUnstableTitle,
        message: isUnstableMessage
      };
    });
};
